// @ts-nocheck

export default {
  "l10n": {
    "currency": '\u20ac',
    "date": {
      "months": {
        "full": ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        "abbr": ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"]
      },
      "days": {
        "full": ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
        "abbr": ["son", "mon", "die", "mit", "don", "fre", "sam"]
      },
      "patterns": {
        "longDate": "dddd, D. MMMM YYYY",
        "dateSlash": "DD/MM/YYYY",
        "dateShort": "dddd, D. MMMM",
        "dateShortWithDay": "Do MMMM YYYY",
        "dateMedium": "dddd, D. MMMM - H[:]mm",
        "dateMediumReversed" : "H[:]mm - D MMMM YYYY",
        "dateMediumSlash": "DD[/]MM[/]YYYY [um] H[:]mm",
        "dateLarge": "D MMM YYYY [um] H[:]mm",
        "timeShort": "LT",
        "timeMedium": "DD[/]MM [•] LT",
        "timeLarge": "DD[/]MM[/]YY [•] LT"
      }
    },
    "number": {
      "patterns": {
        "standard": ["-n", "n"],
        "amount": ["-n S", "n S"]
      },
      "group": {
        "separator": ".",
        "length": 3,
        "abbr": ["", "Tausend", "Million", "Billion"]
      },
      "decimal": {
        "separator": ",",
        "length": 2
      },
      "plural": "nplurals=2; plural=(n != 1);",
      "ordinal": function(number) { return number + (number === 1 ? 'er' : '.'); }
    }
  },
  "translations": {
    "messages": {
  "!action:Bet": [
    null,
    "Wetten"
  ],
  "!action:GiftRace Start": [
    null,
    "Los geht’s"
  ],
  "!action:Settings": [
    null,
    "Einstellen"
  ],
  "!action:Share": [
    null,
    "Teilen"
  ],
  "!action:deleteAndContinue": [
    null,
    "Abbrechen und weiter"
  ],
  "!action:viewMyNonValidatedBets": [
    null,
    "Meine nicht bestätigten Wetten ansehen"
  ],
  "!desc:%1$s ES RM J-30 warning": [
    null,
    ""
  ],
  "!desc:ArjelAdvice": [
    null,
    "Alle Spieler, die sich freiwillig von Spielaktivitäten in Frankreich ausschließen wollen, müssen das französische Innenministerium kontaktieren. Der Selbstausschluss ist für alle Casinos, Spielbanken und Online-Spielseiten gültig, die nach dem Gesetz Nr. 2010-476 vom 12. Mai 2010 zugelassen sind. Die Mindestdauer des Selbstausschlusses beträgt drei Jahre."
  ],
  "!desc:ArjelLink": [
    null,
    "Freiwilliger selbstausschluss von Spielaktivitäten"
  ],
  "!desc:ArjelTitle": [
    null,
    "Winamax est agréé par l'Autorité Nationale des Jeux"
  ],
  "!desc:BROptaWidgetWarning": [
    null,
    "Alle Wettergebnisse in Bezug auf Torschüsse basieren auf den offiziellen Statistiken vom Veranstalter und nicht auf den oben angezeigten Statistiken."
  ],
  "!desc:BasketHowTo": [
    null,
    "Auf eine Quote klicken, um eine Wette hinzuzufügen."
  ],
  "!desc:BetBuilderHelper": [
    null,
    "Mit MyMatch könnt ihr mit mehreren Tipps auf ein Spiel eure eigene Wette erstellen und erhaltet hierfür eine personalisierte Quote."
  ],
  "!desc:BetBuilderHelperBasketball": [
    null,
    "Mit MyMatch könnt ihr mit mehreren Tipps auf ein Spiel eure eigene Wette erstellen (Sieger des Spiels, Anzahl der Punkte/Rebounds/Assists eines Spielers) und erhaltet hierfür eine personalisierte Quote."
  ],
  "!desc:BetBuilderHelperSoccer": [
    null,
    "Mit MyMatch könnt ihr mit mehreren Tipps auf ein Spiel eure eigene Wette erstellen (Ergebnis zur Halbzeit, Genaues Ergebnis, Anzahl der Tore, Torschützen...) und erhaltet hierfür eine personalisierte Quote."
  ],
  "!desc:BetshareWebsite": [
    null,
    "winamax.de"
  ],
  "!desc:BzgaLegals": [
    null,
    "Eigentümer und Betreiber - Winamax SA - 136 B Rue de Grenelle, 75007 Paris, Frankreich\nGlücksspiel kann süchtig machen. Hilfe unter"
  ],
  "!desc:CashoutPendingRegulation": [
    null,
    "Der Cashout-Betrag wird gemäß deutscher Regulierung erst ausgezahlt, wenn alle Auswahlen des Wettscheins ausgewertet sind."
  ],
  "!desc:ClientUpdaterContent": [
    null,
    "Um die App zu aktualisieren, deinstallieren Sie diese bitte und laden Sie im Anschluss die neue App direkt aus dem App Store herunter."
  ],
  "!desc:ClientUpdaterContentDeprecated": [
    null,
    "Diese Version der App beinhaltet nicht die aktuellsten Verbesserungen und wird demnächst blockiert."
  ],
  "!desc:DEBetTaxFreeDescription": [
    null,
    "Wir übernehmen für Dich die Wettsteuer i. H. v. 5,3% auf den Wetteinsatz. Bei uns wettest Du garantiert steuerfrei, das heißt mehr Gewinne für Dich!"
  ],
  "!desc:DVTMLink": [
    null,
    "Verantwortliches Spiel"
  ],
  "!desc:DgojConfidentiality": [
    null,
    "Política de privacidad"
  ],
  "!desc:DgojLicence": [
    null,
    "\n        WINAMAX Sociedad Anónima (S.A.) cuya sede social se encuentra en 136bis Rue de Grenelle, 75007 París France.\n        Todos los derechos reservados.\n\n        WINAMAX se responsabiliza de este sitio web, al que la Dirección General de Ordenación del Juego le ha concedido las siguientes licencias: POQUER No/Ref: POQ/2018/001, APUESTAS DEPORTIVAS DE CONTRAPARTIDA No/Ref: ADC/2018/017\n\n        Está prohibida la participación de los menores de edad y los incapacitados legalmente o por resolución judicial.\n      "
  ],
  "!desc:DgojResponsibleGaming": [
    null,
    "Juego responsable"
  ],
  "!desc:DgojResponsibleGamingTextES": [
    null,
    "This is a real money gambling application. Please play responsibly and only bet what you can afford. For help and support with gambling addiction, please contact FEJAR at 900 533 025 or visit https://fejar.org/"
  ],
  "!desc:DgojTerms": [
    null,
    "Términos y condiciones"
  ],
  "!desc:DocumentTitle": [
    null,
    "Sportwetten | Winamax Sportwetten | Online Sportwetten"
  ],
  "!desc:DocumentTitleLive": [
    null,
    "Live-Wetten – Gebt auf Winamax eure Live-Sportwetten ab"
  ],
  "!desc:FreebetHelper": [
    null,
    "Freebets erhaltet ihr im Rahmen bestimmter Promotionen.\nFür gewonnene Freebets wird euch der Nettogewinn (Gewinn – Einsatz) gutgeschrieben."
  ],
  "!desc:GoalScorersHelper": [
    null,
    "Wettet auf einen Spieler/eine Spielerin, der/die mindestens ein Tor oder exakt das erste oder letzte Tor im Spiel erzielt. Verlängerungen und Elfmeterschießen werden nicht berücksichtigt. Eigentore werden ebenfalls nicht berücksichtigt. Falls es sich beim ersten (oder entsprechend letztem) Tor des Spiels um ein Eigentor handelt, so wird der Spieler der das nächste Tor erzielt (bzw. entsprechend das vorletzte Tor) als erster (letzter) Torschütze des Spiels gewertet."
  ],
  "!desc:Minus18DE": [
    null,
    "Minderjährigen ist die Benutzung verboten"
  ],
  "!desc:MonopolyEnrollmentMessage": [
    null,
    "Vervollständige deine Monopoly-Kollektionen durch deine Wetten und gewinne Freebets!"
  ],
  "!desc:PanicButtonConfirmation": [
    null,
    "Sie haben eine anbieterübergreifende 24-Stunden-Sperre aktiviert. Ihr Account steht somit erst wieder morgen ab %1$s Uhr zur Verfügung."
  ],
  "!desc:PanicButtonConfirmationTitle": [
    null,
    "Ihr Account ist gesperrt"
  ],
  "!desc:RealityCheckMessage": [
    null,
    "Bitte denk dran, regelmäßig Pausen einzulegen. Weitere Informationen findest Du auch in der Rubrik \"Spielerschutz“."
  ],
  "!desc:ResponsibleGamingTextFR": [
    null,
    "This is a real-money gambling app. Please gamble responsibly and only bet what you can afford. For gambling addiction help and support, please contact (joueurs-info-service at 09-74-75-13-13or visit http://www.joueurs-info-service.fr/."
  ],
  "!desc:SoccerDecisivePlayer": [
    null,
    "Bei den beiden Wetten \"Schlüsselspieler\" und \"Vorlagengeber\" sind die Wetten ungültig, wenn der betreffende Spieler nicht spielt. Zudem basiert das Ergebnis der Wetten auf den Opta-Statistiken.\nDer Spieler wird zum Schlüsselspieler sofern er mindestens ein Tor oder eine Vorlage erzielt (ohne Verlängerung(en)/Penalty)."
  ],
  "!desc:SoccerScorerDuo": [
    null,
    "Wettet auf die Anzahl der von diesen beiden Spielern erzielten Tore (außer Verlängerung und Elfmeterschießen). Die Wette wird erstattet, sofern einer der beiden ausgewählten Spieler nicht am Spiel teilnimmt."
  ],
  "!desc:SoccerScorerTrio": [
    null,
    "Wettet auf die Anzahl der von diesen drei Spielern erzielten Tore (außer Verlängerung und Elfmeterschießen). Die Wette wird erstattet, sofern einer der drei ausgewählten Spieler nicht am Spiel teilnimmt."
  ],
  "!desc:SrijLicence": [
    null,
    "WINAMAX, S.A. Todos os direitos reservados. É uma empresa registada em Portugal com o número de empresa XXXXXXXXX, com sede na XXXXXXXX, em XXXXX e é titular das licenças de jogo n° XXX e XXX emitidas pelo SRIJ – Serviço de Regulação e Inspeção de Jogos que a autoriza a desenvolver a atividade de exploração de apostas desportivas à cota e de jogos de fortuna ou azar online em Portugal."
  ],
  "!desc:activateLineUpNotifications": [
    null,
    "Du willst eine Benachrichtigung auf deinem Handy erhalten, sobald die Aufstellungen deiner favorisierten Spiele feststehen?\nAktiviere deine Benachrichtigungen jetzt auf deinem Account"
  ],
  "!desc:userAlreadyOptedIn": [
    null,
    "Sie nehmen bereits an der Aktion teil."
  ],
  "!noun:GridsCancelled": [
    null,
    "-"
  ],
  "!noun:GridsFilterCancelled": [
    null,
    "-"
  ],
  "!noun:GridsFilterLost": [
    null,
    "-"
  ],
  "!noun:GridsFilterRunning": [
    null,
    "-"
  ],
  "!noun:GridsFilterWon": [
    null,
    "-"
  ],
  "!noun:GridsFinancing": [
    null,
    "-"
  ],
  "!noun:GridsFinished": [
    null,
    "-"
  ],
  "!noun:GridsLost": [
    null,
    "-"
  ],
  "!noun:GridsNotValidated": [
    null,
    "-"
  ],
  "!noun:GridsRunning": [
    null,
    "-"
  ],
  "!noun:GridsWon": [
    null,
    "-"
  ],
  "!noun:MonopolyWon": [
    "!noun:MonopolyWonPlural",
    "Besitz:",
    "Besitz:"
  ],
  "!noun:Rules": [
    null,
    "Regeln"
  ],
  "!noun:Welcome": [
    null,
    "Herzlich Willkommen"
  ],
  "!noun:Won": [
    null,
    "Gewonnen"
  ],
  "!plural:Finished": [
    null,
    "Beendet"
  ],
  "!plural:Won": [
    null,
    "Gewonnen"
  ],
  "!scorer:Next": [
    null,
    "Nächster"
  ],
  "!short:1st half - 2 or more": [
    null,
    "1. Halbzeit - 2 und mehr"
  ],
  "!short:1st half - 3 or more": [
    null,
    "1. Halbzeit - 3 und mehr"
  ],
  "!short:1st half - 4 or more": [
    null,
    "1. Halbzeit - 4 und mehr"
  ],
  "!short:1st period - Scorer": [
    null,
    "1. Drittel - Torschütze"
  ],
  "!short:2 or more": [
    null,
    "2 und mehr"
  ],
  "!short:2nd half - 2 or more": [
    null,
    "2. Halbzeit - 2 und mehr"
  ],
  "!short:2nd half - 3 or more": [
    null,
    "2. Halbzeit - 3 und mehr"
  ],
  "!short:2nd half - 4 or more": [
    null,
    "2. Halbzeit - 4 und mehr"
  ],
  "!short:2nd period - Scorer": [
    null,
    "2. Drittel - Torschütze"
  ],
  "!short:3 or more": [
    null,
    "3 und mehr"
  ],
  "!short:3rd period - Scorer": [
    null,
    "3. Drittel - Torschütze"
  ],
  "!short:4 or more": [
    null,
    "4 und mehr"
  ],
  "!short:AdditionnalTime": [
    null,
    "EI"
  ],
  "!short:Anytime goalscorer": [
    null,
    "Torschütze"
  ],
  "!short:BothHalf": [
    null,
    "Beide"
  ],
  "!short:Double": [
    null,
    "Double"
  ],
  "!short:Draw": [
    null,
    "X"
  ],
  "!short:First": [
    null,
    "Erster"
  ],
  "!short:FirstHalf": [
    null,
    "1. Halbzeit"
  ],
  "!short:HalfTime": [
    null,
    "HZ"
  ],
  "!short:Hat-trick": [
    null,
    "Hattrick"
  ],
  "!short:Last": [
    null,
    "Letzter"
  ],
  "!short:Next": [
    null,
    "Nächster"
  ],
  "!short:Overtime": [
    null,
    "DT"
  ],
  "!short:Overtime - 2 or more": [
    null,
    "Verlängerung - 2 und mehr"
  ],
  "!short:PenaltyShootOut": [
    null,
    "ELFM"
  ],
  "!short:Points": [
    null,
    "PKT"
  ],
  "!short:RegularTime": [
    null,
    "Reg Spielzeit"
  ],
  "!short:ScorerConversion": [
    null,
    "C"
  ],
  "!short:ScorerDrop": [
    null,
    "D"
  ],
  "!short:ScorerPenalty": [
    null,
    "P"
  ],
  "!short:SecondHalf": [
    null,
    "2. Halbzeit"
  ],
  "!short:Today": [
    null,
    "Heute"
  ],
  "!short:bet": [
    "!short:bets",
    "Wette",
    "Wetten"
  ],
  "%1$s (multiple chance)": [
    null,
    "%1$s Multi-Chance"
  ],
  "%1$s + %2$s": [
    null,
    "%1$s + %2$s"
  ],
  "%1$s Base": [
    "%1$s Bases",
    "%1$s Bank",
    "%1$s Banken"
  ],
  "%1$s bet": [
    "%1$s bets",
    "%1$s Wette",
    "%1$s Wetten"
  ],
  "%1$s bet added": [
    "%1$s bets added",
    "%1$s Wette hinzugefügt",
    "%1$s Wetten hinzugefügt"
  ],
  "%1$s bet could not be validated": [
    "%1$s bets could not be validated",
    "%1$s Wette konnte nicht validiert werden",
    "%1$s Wetten konnten nicht validiert werden"
  ],
  "%1$s bet selected": [
    "%1$s bets selected",
    "%1$s Wette ausgewählt",
    "%1$s Wetten ausgewählt"
  ],
  "%1$s guarenteed ": [
    null,
    "-"
  ],
  "%1$s or more": [
    null,
    "%1$s oder mehr"
  ],
  "%1$s selection": [
    "%1$s selections",
    "%1$s Tipp",
    "%1$s Tipps"
  ],
  "%1$s selection could not be added": [
    "%1$s selections could not be added",
    "%1$s Wette konnte nicht hinzugefügt werden",
    "%1$s Wetten konnten nicht hinzugefügt werden"
  ],
  "%1$s single bet": [
    "%1$s single bets",
    "%1$s Wette Einzel",
    "%1$s Wette Einzel"
  ],
  "%1$s's bet": [
    null,
    "%1$s's Wette"
  ],
  "%1$s-%2$s PSO": [
    null,
    "%1$s-%2$s 11m"
  ],
  "%1$s-%2$s a.e.t.": [
    null,
    "%1$s-%2$s n. Verl."
  ],
  "%1$s-%2$s reg. time": [
    null,
    "%1$s-%2$s reg. Spielzeit"
  ],
  "%1$s:": [
    null,
    "%1$s:"
  ],
  "(1 to %1$s)": [
    null,
    "-"
  ],
  "+%1$s min": [
    null,
    "+%1$s min."
  ],
  "10th set": [
    null,
    "10. Satz"
  ],
  "12-grids": [
    null,
    "-"
  ],
  "1st": [
    null,
    "1."
  ],
  "1st half": [
    null,
    "1. Halbzeit"
  ],
  "1st innings": [
    null,
    "1. Inning"
  ],
  "1st period": [
    null,
    "1. Spielabschnitt"
  ],
  "1st quarter": [
    null,
    "1. Viertel"
  ],
  "1st set": [
    null,
    "1. Satz"
  ],
  "2 or more": [
    null,
    "2 und mehr"
  ],
  "24-hour break": [
    null,
    "24h Sperre"
  ],
  "2nd": [
    null,
    "2."
  ],
  "2nd half": [
    null,
    "2. Halbzeit"
  ],
  "2nd half - Multiple goalscorers": [
    null,
    "2. Halbzeit - Mehrfacher Torschütze"
  ],
  "2nd innings": [
    null,
    "2. Inning"
  ],
  "2nd period": [
    null,
    "2. Spielabschnitt"
  ],
  "2nd quarter": [
    null,
    "2. Viertel"
  ],
  "2nd set": [
    null,
    "2. Satz"
  ],
  "3 or more": [
    null,
    "3 und mehr"
  ],
  "3rd": [
    null,
    "3."
  ],
  "3rd innings": [
    null,
    "3. Inning"
  ],
  "3rd period": [
    null,
    "3. Spielabschnitt"
  ],
  "3rd quarter": [
    null,
    "3. Viertel"
  ],
  "3rd set": [
    null,
    "3. Satz"
  ],
  "4 or more": [
    null,
    "4 und mehr"
  ],
  "4th innings": [
    null,
    "4. Inning"
  ],
  "4th quarter": [
    null,
    "4. Viertel"
  ],
  "4th set": [
    null,
    "4. Satz"
  ],
  "5th innings": [
    null,
    "5. Inning"
  ],
  "5th set": [
    null,
    "5. Satz"
  ],
  "6th innings": [
    null,
    "6. Inning"
  ],
  "6th set": [
    null,
    "6. Satz"
  ],
  "7-grids": [
    null,
    "-"
  ],
  "7th innings": [
    null,
    "7. Inning"
  ],
  "7th set": [
    null,
    "7. Satz"
  ],
  "8th innings": [
    null,
    "8. Inning"
  ],
  "8th set": [
    null,
    "8. Satz"
  ],
  "9th innings": [
    null,
    "9. Inning"
  ],
  "9th set": [
    null,
    "9. Satz"
  ],
  "A server issue has interrupted media playback.": [
    null,
    "Ein Netzwerkproblem hat die Videowiedergabe unterbrochen."
  ],
  "ALL-IN": [
    null,
    "ALL-IN"
  ],
  "Accept changes": [
    null,
    "Neue Quote akzeptieren"
  ],
  "Acces to media failed.": [
    null,
    "Der Zugriff auf das Medium ist fehlgeschlagen."
  ],
  "Accumulator": [
    null,
    "Kombi"
  ],
  "Accumulator %1$s": [
    null,
    "Kombiwette %1$s"
  ],
  "Add": [
    null,
    "Hinzufügen"
  ],
  "Add an In-Play selection to get a %1$s bonus": [
    null,
    "Einen Live-Tipp hinzufügen, um einen Bonus i. H. v. %1$s zu erhalten"
  ],
  "Add bet to basket": [
    null,
    "Wette zum Wettschein hinzufügen"
  ],
  "Add one selection to get a %1$s bonus": [
    null,
    "Einen Tipp hinzufügen, um einen Bonus i. H. v. %1$s zu erhalten"
  ],
  "Additional buttons allow you to make variations of an existing grid.": [
    null,
    "-"
  ],
  "Ajax Amsterdam": [
    null,
    "-"
  ],
  "All": [
    null,
    "Alle"
  ],
  "All my grids": [
    null,
    "-"
  ],
  "All players": [
    null,
    "Alle Spieler"
  ],
  "All possible accumulators %1$s with %2$s from %3$s others, or %4$s in total": [
    null,
    "Alle möglichen Kombinationen %1$s mit %2$s bis%3$s anderen oder %4$s insgesamt"
  ],
  "All possible accumulators from the %1$s from amongst %2$s, or %3$s in total": [
    null,
    "Alle möglichen Kombiwetten mit %1$s aus den %2$s, also %3$s Wetten insgesamt"
  ],
  "All rules": [
    null,
    "Alle Regeln"
  ],
  "Amount": [
    null,
    "-"
  ],
  "Amount collected:": [
    null,
    "-"
  ],
  "Amount shared out:": [
    null,
    "-"
  ],
  "Amount to be carried forward:": [
    null,
    "-"
  ],
  "An error as occurred.": [
    null,
    "Ein Fehler ist aufgetreten. "
  ],
  "An error has occured": [
    null,
    "Ein Fehler ist aufgetreten"
  ],
  "An error occurred, please try again.": [
    null,
    "Ein Fehler ist aufgetreten, bitte erneut versuchen."
  ],
  "And remember,": [
    null,
    "-"
  ],
  "And you will unlock phase 2.": [
    null,
    "Und ihr schaltet Phase 2 frei."
  ],
  "And you will unlock phase 3.": [
    null,
    "Und ihr schaltet Phase 3 frei."
  ],
  "Anytime": [
    null,
    "Torschütze"
  ],
  "Assistman": [
    null,
    "Passgeber"
  ],
  "Assists": [
    null,
    "Assists"
  ],
  "Assists+rebounds": [
    null,
    "Assists+rebounds"
  ],
  "At least one of the two teams": [
    null,
    "Mindestens eine der beiden Mannschaften"
  ],
  "At least one of your multi-chance selections has too many choices.": [
    null,
    "Mindestens eine deiner Multi-Chance Wetten beträgt zu viele Auswahlen."
  ],
  "At least one of your selections is currently suspended": [
    null,
    "Mindestens eine deiner Auswahlen ist momentan ausgesetzt."
  ],
  "At least one of your selections is no longer available.": [
    null,
    "Mindestens eine deiner Auswahlen ist nicht mehr verfügbar."
  ],
  "At least one of your selections is no longer available. Check your betslip.": [
    null,
    "Mindestens eine deiner Auswahlen ist nicht mehr verfügbar. Überprüfe deinen Wettschein."
  ],
  "At least one of your selections is not eligible for MyMatch.": [
    null,
    "Mindestens eine deiner Auswahlen ist für MyMatch nicht geeignet."
  ],
  "At least one of your selections is not eligible for MyMatch. Check your betslip.": [
    null,
    "Mindestens eine deiner Auswahlen ist für MyMatch nicht geeignet. Überprüfe deinen Wettschein."
  ],
  "Atletico Madrid": [
    null,
    "-"
  ],
  "Author": [
    null,
    "-"
  ],
  "BOOM, easy game!": [
    null,
    "-"
  ],
  "Back": [
    null,
    "Zurück"
  ],
  "Back to grid creation": [
    null,
    "-"
  ],
  "Back to sports betting": [
    null,
    "-"
  ],
  "Back to the grid of the day": [
    null,
    "-"
  ],
  "Balance": [
    null,
    "Guthaben"
  ],
  "Base": [
    null,
    "Bank"
  ],
  "Bayern Munich": [
    null,
    "-"
  ],
  "Best author (badge)": [
    null,
    "-"
  ],
  "Best author (winnings)": [
    null,
    "-"
  ],
  "Best bets": [
    null,
    "Die besten Wetten"
  ],
  "Bet": [
    null,
    "Wette"
  ],
  "Bet %1$s could not be redeemed, one or more selections are not eligible for Cashout": [
    null,
    "Die Wette %1$s kann nicht zurückgekauft werden, da ein oder mehrere Tipps nicht für den Cashout zur Verfügung stehen"
  ],
  "Bet %1$s could not be redeemed, remaining bet is less than €0.10": [
    null,
    "Die Wette %1$s kann nicht zurückgekauft werden, da der vebleibende Einsatz unter 0,10 € liegt"
  ],
  "Bet %1$s could not be redeemed, the Cashout amount has changed": [
    null,
    "Die %1$s kann nicht zurückgekauft werden, da sich der Betrag des Cashouts geändert hat"
  ],
  "Bet confirmation": [
    null,
    "Bestätigung der Wette"
  ],
  "Bet is limited to free bet": [
    null,
    "Wette gilt nur für Gratiswetten"
  ],
  "Bet is not eligible for Boom %1$s": [
    null,
    "Die Wette ist nicht qualifiziert für den Boom %1$s"
  ],
  "Bet is not eligible for Boom %1$s because at least one match starts after the end of the game": [
    null,
    "Die Wette ist nicht qualifiziert für den Boom %1$s, da mindestens ein Spiel nach Ablauf des Wettlaufs beginnt"
  ],
  "Bet is not eligible for Boom %1$s because system bets are not eligible": [
    null,
    "Die Wette ist nicht qualifiziert für den Boom %1$s, da Systemwetten nicht wählbar sind"
  ],
  "Bet is not eligible for Boom %1$s because the game is not in progress": [
    null,
    "Die Wette ist nicht qualifiziert für den Boom %1$s, da das Spiel noch nicht begonnen hat"
  ],
  "Bet is not eligible for Boom %1$s because the match starts in over 48 hours": [
    null,
    "Die Wette ist nicht qualifiziert für den Boom %1$s, da das Spiel in mehr als 48h beginnt"
  ],
  "Bet is not eligible for Boom %1$s because you have a bet in the validation process": [
    null,
    "Die Wette kann nicht für Boom %1$s gewertet werden, da Du eine noch nicht bestätigte Wette abgegeben hast"
  ],
  "Bet is not eligible for Boom %1$s because you have already placed an eligible bet on the same match": [
    null,
    "Die Wette ist nicht qualifiziert für den Boom %1$s, da du bereits eine Wette auf das Spiel platziert hast"
  ],
  "Bet is not eligible for Boom %1$s because you have not started the game": [
    null,
    "Die Wette ist nicht qualifiziert für den Boom %1$s, da du noch nicht mit dem Spiel begonnen hast"
  ],
  "Bet is not eligible for Monopoly": [
    null,
    "Die Wette ist nicht qualifiziert für den Monopoly"
  ],
  "Bet is not eligible for Monopoly because at least one match starts after the end of the game": [
    null,
    "Die Wette ist nicht qualifiziert für den Monopoly, da mindestens ein Spiel nach Ablauf des Wettlaufs beginnt"
  ],
  "Bet is not eligible for Monopoly because system bets are not eligible": [
    null,
    "Die Wette ist nicht qualifiziert für den Monopoly, da Systemwetten nicht wählbar sind"
  ],
  "Bet is not eligible for Monopoly because the game is not in progress": [
    null,
    "Die Wette ist nicht qualifiziert für den Monopoly, da das Spiel noch nicht begonnen hat"
  ],
  "Bet is not eligible for Monopoly because the match starts in over 48 hours": [
    null,
    "Die Wette ist nicht qualifiziert für den Monopoly, da das Spiel in mehr als 48h beginnt"
  ],
  "Bet is not eligible for Monopoly because you have already placed an eligible bet on the same match": [
    null,
    "Die Wette ist nicht qualifiziert für den Monopoly, da du bereits eine Wette auf das Spiel platziert hast"
  ],
  "Bet is not eligible for Monopoly because you have not started the game": [
    null,
    "Die Wette ist nicht qualifiziert für den Monopoly, da du noch nicht mit dem Spiel begonnen hast"
  ],
  "Bet is not eligible for the Gift Race": [
    null,
    "Die Wette ist nicht qualifiziert für den Wettlauf der Geschenke"
  ],
  "Bet is not eligible for the Gift Race because at least one match starts after the end of the game": [
    null,
    "Die Wette ist nicht qualifiziert für den Wettlauf der Geschenke, da mindestens ein Spiel nach Ablauf des Wettlaufs beginnt"
  ],
  "Bet is not eligible for the Gift Race because system bets are not eligible": [
    null,
    "Die Wette ist nicht qualifiziert für den Wettlauf der Geschenke, da Systemwetten nicht wählbar sind"
  ],
  "Bet is not eligible for the Gift Race because the game is not in progress": [
    null,
    "Die Wette ist nicht qualifiziert für den Wettlauf der Geschenke, da das Spiel noch nicht begonnen hat"
  ],
  "Bet is not eligible for the Gift Race because the match starts in over 48 hours": [
    null,
    "Die Wette ist nicht qualifiziert für den Wettlauf der Geschenke, da das Spiel in mehr als 48h beginnt"
  ],
  "Bet is not eligible for the Gift Race because this version of the game has ended": [
    null,
    "Die Wette ist nicht qualifiziert für den Wettlauf der Geschenke, da diese Version des Spiels beendet ist"
  ],
  "Bet is not eligible for the Gift Race because you have a reward to collect in order to unlock the next gift": [
    null,
    "Die Wette ist nicht qualifiziert für den Wettlauf der Geschenke, da du dir zuerst deine Belohnung holen musst, um das nächste Geschenk freizuschalten"
  ],
  "Bet is not eligible for the Gift Race because you have already placed an eligible bet on the same match": [
    null,
    "Die Wette ist nicht qualifiziert für den Wettlauf der Geschenke, da du bereits eine Wette auf das Spiel platziert hast"
  ],
  "Bet is not eligible for the Gift Race because you have already won the gift": [
    null,
    "Die Wette ist nicht qualifiziert für den Wettlauf der Geschenke, da du das Geschenk bereits erhalten hast"
  ],
  "Bet is not eligible for the Gift Race because you have not started the game": [
    null,
    "Die Wette ist nicht qualifiziert für den Wettlauf der Geschenke, da du noch nicht mit dem Spiel begonnen hast"
  ],
  "Bet is not eligible for the Gift Race because you must start the gift quest again": [
    null,
    "Die Wette ist nicht qualifiziert für den Wettlauf der Geschenke, da du zuerst mit der Sammlung nach Geschenken beginnen musst"
  ],
  "Bet is not eligible for the Gift Race because your current bets will be decisive": [
    null,
    "Die Wette ist nicht qualifiziert für den Wettlauf der Geschenke, da deine laufenden Wetten entscheidend sind"
  ],
  "Bet modification unavailable": [
    null,
    "Keine Änderung möglich"
  ],
  "Bet modification unavailable with free bets": [
    null,
    "Keine Änderung bei Gratiswetten möglich"
  ],
  "Bet pending": [
    null,
    "Wette anstehend"
  ],
  "Bet refused": [
    null,
    "Wette abgelehnt"
  ],
  "Bet stopped": [
    null,
    "Wette beendet"
  ],
  "Bet suspended": [
    null,
    "Wette ausgesetzt"
  ],
  "Bet tax free": [
    null,
    "Steuerfrei wetten"
  ],
  "Bet validated": [
    null,
    "Wette bestätigt"
  ],
  "Bet validated!": [
    null,
    "Wette bestätigt!"
  ],
  "Bet validation in progress": [
    null,
    "Wette wird bestätigt"
  ],
  "Bets on the competition": [
    null,
    "Wetten auf den Wettbewerb"
  ],
  "Betslip": [
    null,
    "Wetten"
  ],
  "Betting with Winamax": [
    null,
    "Online wetten bei Winamax"
  ],
  "Biggest accumulators": [
    null,
    "Die besten Kombiwetten"
  ],
  "Biggest winnings": [
    null,
    "Größte Gewinne"
  ],
  "Blocks": [
    null,
    "Blocks"
  ],
  "Boom %1$s internal error": [
    null,
    "Interner Fehler bei dem Boom %1$s"
  ],
  "Boom St Valentine": [
    null,
    "Boom Valentinstag"
  ],
  "Borussia M'Gladbach": [
    null,
    "-"
  ],
  "Both teams": [
    null,
    "Beide Mannschaften"
  ],
  "Bracket": [
    null,
    "Bracket"
  ],
  "Bravo!": [
    null,
    "Bravo!"
  ],
  "By ticking this box, your grid will be made private.": [
    null,
    "-"
  ],
  "Cancelled": [
    null,
    "Annulliert"
  ],
  "Cashout": [
    null,
    "Cashout"
  ],
  "Cashout (max %1$s)": [
    null,
    "Cashout (max. %1$s)"
  ],
  "Cashout validated": [
    null,
    "Cashout validiert"
  ],
  "Cashout validation in progress": [
    null,
    "Cashout wird bearbeitet"
  ],
  "Cashout €%1$s": [
    null,
    "Cashout %1$s €"
  ],
  "Cashout: %2$s available": [
    "Cashout: %2$s available",
    "%2$s verfügbar",
    "%2$s verfügbar"
  ],
  "Certain data may not be up to date.": [
    null,
    "Eine Daten sind möglicherweise nicht aktuell."
  ],
  "Check out the public grids as well as information about the authors of these grids and find the one that suits you best.": [
    null,
    "-"
  ],
  "Check the full rules": [
    null,
    "Finde hier die gesamten Regeln"
  ],
  "Choose the amount of your stake on this grid as a team.": [
    null,
    "-"
  ],
  "Choose your format (7 or 12 matches) and validate your own grid.": [
    null,
    "-"
  ],
  "Christmas is already over!": [
    null,
    "Weihnachten ist schon vorbei!"
  ],
  "Claim": [
    null,
    "Holen"
  ],
  "Click and hold an image to save or share": [
    null,
    "Bild dauerhaft anklicken um es zu speichern oder zu teilen"
  ],
  "Close": [
    null,
    "Schließen"
  ],
  "Close details": [
    null,
    "-"
  ],
  "Combinations": [
    null,
    "Kombi"
  ],
  "Combo booster": [
    null,
    "Kombi-Booster"
  ],
  "Compact grid": [
    null,
    "-"
  ],
  "Compact view": [
    null,
    "-"
  ],
  "Competitions": [
    null,
    "Wettbewerbe"
  ],
  "Complete all 3 phases of the game by placing winning bets and walk away with legendary gifts and lots of Freebets:": [
    null,
    "Erreiche alle drei Phasen des Spiels, indem du eine Wette nach der anderen abschließt und mit legendären Geschenken und vielen Freebets nach Hause gehst:"
  ],
  "Complete bet": [
    null,
    "Meine Wette ergänzen"
  ],
  "Confirm": [
    null,
    "Bestätigen"
  ],
  "Congratulations on your journey!": [
    null,
    "Herzlichen Glückwunsch!"
  ],
  "Congratulations!": [
    null,
    "-"
  ],
  "Connection error.": [
    null,
    "Verbindungsfehler."
  ],
  "Contradictory selections": [
    null,
    "Sich widersprechende Auswahlen"
  ],
  "Contradictory selections.": [
    null,
    "Widersprüchliche Auswahlen."
  ],
  "Contradictory selections. Check your betslip.": [
    null,
    "Widersprüchliche Auswahlen. Überprüfe deinen Wettschein."
  ],
  "Copied": [
    null,
    "-"
  ],
  "Copy": [
    null,
    "-"
  ],
  "Copy the link": [
    null,
    "-"
  ],
  "Countries": [
    null,
    "Länder"
  ],
  "Dead-Heat": [
    null,
    "Gleichstand"
  ],
  "Decisive": [
    null,
    "Schlüsselsp"
  ],
  "Decisive players": [
    null,
    "Schlüsselspieler"
  ],
  "Delete grid": [
    null,
    "-"
  ],
  "Delete my favourites": [
    null,
    "Alle Favoriten entfernen"
  ],
  "Detailed grids": [
    null,
    "-"
  ],
  "Didn't understand everything on the previous screen?": [
    null,
    "-"
  ],
  "Direct free kick": [
    null,
    "Direkter Freistoß"
  ],
  "Display sliders on relevant bets by default": [
    null,
    "Standardmäßig die Cursor auf den betreffenden Wetten anzeigen"
  ],
  "Do you like this application?": [
    null,
    "Gefällt Ihnen diese App?"
  ],
  "Do you want to keep a low profile and only share your grid with your friends? Opt for the private grid.": [
    null,
    "-"
  ],
  "Do you wish to comment on this application?": [
    null,
    "Möchten Sie einen Kommentar abgeben?"
  ],
  "Don't save bet": [
    null,
    "Wette nicht mehr speichern"
  ],
  "Draw": [
    null,
    "-"
  ],
  "Duplicate grid": [
    null,
    "-"
  ],
  "Each simple bet is placed individually": [
    null,
    "Jede Einzelwette wird einzeln platziert"
  ],
  "Edit": [
    null,
    "Bearbeiten"
  ],
  "Enhance": [
    null,
    "Ergänzen"
  ],
  "Error whilst crediting your reward": [
    null,
    "Fehler bei der Vergabe deiner Belohnung"
  ],
  "Error, please try again": [
    null,
    "Fehler. Bitte erneut versuchen."
  ],
  "Event abandoned": [
    null,
    "Veranstaltung abgebrochen"
  ],
  "Event cancelled": [
    null,
    "Veranstaltung abgesagt"
  ],
  "Event ended": [
    null,
    "Wettbewerb beendet"
  ],
  "Event postponed": [
    null,
    "Veranstaltung verschoben"
  ],
  "Eventual winnings will be shared in proportion to each player's stake.": [
    null,
    "-"
  ],
  "Excluding extra-time and penalty shoot-out.": [
    null,
    "Außer Verlängerung und Elfmeterschießen."
  ],
  "Explode Cupid by winnings 5 bets": [
    null,
    "Lass Amor explodieren indem du 5 Wetten gewinnst"
  ],
  "Explode the leprechaun by winnings 5 bets": [
    null,
    "Lasst den Kobold explodieren, indem ihr 5 Wetten gewinnt"
  ],
  "Explode your pumpkin by winnings 5 bets": [
    null,
    "Lass den Kürbis explodieren indem du 5 Wetten gewinnst"
  ],
  "Extras": [
    null,
    "Extras"
  ],
  "FC Porto": [
    null,
    "-"
  ],
  "Filter bets": [
    null,
    "Wetten filtern"
  ],
  "Finance your entire grid or share the jackpot by playing as a team.": [
    null,
    "-"
  ],
  "Find out how much you've pocketed as soon as the last game of your grid ends.": [
    null,
    "-"
  ],
  "First": [
    null,
    "Erster"
  ],
  "Flash": [
    null,
    "-"
  ],
  "Follow the live results and stats of your grids.": [
    null,
    "-"
  ],
  "For a 24h break hold the button pressed for 3 seconds.": [
    null,
    "Für 24h Sofortsperre den Button 3 Sekunden gedrückt halten."
  ],
  "Format change": [
    null,
    "Änderung des Formats"
  ],
  "Frame %1$s": [
    null,
    "Frame %1$s"
  ],
  "Freebet Wager": [
    null,
    "Freebets-Einsatz"
  ],
  "Freebet win for the complete colour collection: Reference bet x %1$s": [
    null,
    "Freebets-Gewinn, wenn die Farbkollektion komplett ist: Referenzeinsatz x %1$s"
  ],
  "Freebet winnings if you win this level: Reference bet x %1$s": [
    null,
    "Freebet-Gewinn, wenn das du das Level gewinnst: Referenzeinsatz x %1$s"
  ],
  "Freebets Wager": [
    null,
    "Freebets-Einsatz"
  ],
  "Game objective": [
    null,
    "Spielziel"
  ],
  "Gather properties, complete colour collections and win lots of Freebets!": [
    null,
    "Hol dir deine Strassen, vervollständige deine Farbkollektionen und gewinne jede Menge Freebets!"
  ],
  "General problem": [
    null,
    "Allgemeines Problem."
  ],
  "Get started": [
    null,
    "-"
  ],
  "Gift Race internal error": [
    null,
    "Interner Fehler bei dem Wettlauf der Geschenke"
  ],
  "Goalscorer Duo": [
    null,
    "Torschützen-Duo"
  ],
  "Goalscorer Guarantee": [
    null,
    "Torschützen-Garantie"
  ],
  "Goalscorer Trio": [
    null,
    "Torschützen-Trio"
  ],
  "Goalscorer in a period": [
    null,
    "Torschützen im Drittel"
  ],
  "Goalscorers in a 10 min period": [
    null,
    "Torschütze in einem 10-Minuten-Intervall"
  ],
  "Goalscorers in a 15 min period": [
    null,
    "Torschütze in einem 15-Minuten-Intervall"
  ],
  "Graphics preferences": [
    null,
    "Grafikeinstellungen"
  ],
  "Grid": [
    null,
    "Grid"
  ],
  "Grid %1$s winnings": [
    null,
    "-"
  ],
  "Grid price": [
    null,
    "-"
  ],
  "Grid result": [
    null,
    "-"
  ],
  "Grids": [
    null,
    "-"
  ],
  "Grids Home": [
    null,
    "-"
  ],
  "Guarantee:": [
    null,
    "-"
  ],
  "Half time - Multiple goalscorers": [
    null,
    "Halbzeit – Mehrfacher Torschütze"
  ],
  "Half-time goalscorers": [
    null,
    "Torschütze in einer Halbzeit"
  ],
  "Halloween": [
    null,
    "Halloween"
  ],
  "Header": [
    null,
    "Kopfball"
  ],
  "Hidden": [
    null,
    "Ausgeblendet"
  ],
  "Hide bet": [
    null,
    "Wette ausblenden"
  ],
  "Highest MyMatch odds": [
    null,
    "Die größten MyMatch Quoten"
  ],
  "Highest odds": [
    null,
    "Die größten Quoten"
  ],
  "Home": [
    null,
    "Home"
  ],
  "If you lose a bet, you start the phase from 0.": [
    null,
    "Falls ihr eure Wette verliert, beginnt ihr in der Phase von vorne."
  ],
  "Important account information": [
    null,
    "Informationen bezüglich Ihres Kontos"
  ],
  "In Play": [
    null,
    "Live"
  ],
  "In progress": [
    null,
    "In Bearbeitung"
  ],
  "Incorrect PIN": [
    null,
    "Falscher PIN-Code"
  ],
  "Incorrect amount": [
    null,
    "Ungültiger Betrag"
  ],
  "Incorrect email, password or date of birth": [
    null,
    "E-Mail/Passwort/Geburtsdatum falsch"
  ],
  "Individual grid": [
    null,
    "-"
  ],
  "Inter Milan": [
    null,
    "-"
  ],
  "Internal error": [
    null,
    "Interner Fehler"
  ],
  "It's not the grids that matter, it's what you do with them!": [
    null,
    "-"
  ],
  "It's simple! Select a result of your choice (team 1 or team 2 or draw) for each match.": [
    null,
    "-"
  ],
  "Koh-Lanta": [
    null,
    ""
  ],
  "Lacking inspiration? You can also take part in a public grid.": [
    null,
    "-"
  ],
  "Last": [
    null,
    "Letzter"
  ],
  "Later": [
    null,
    "Later"
  ],
  "Least expensive": [
    null,
    "-"
  ],
  "Less selections": [
    null,
    "Weniger anzeigen"
  ],
  "Level %1$s": [
    null,
    "Level %1$s"
  ],
  "Line %1$s": [
    null,
    "Reihe %1$s"
  ],
  "Link copied!": [
    null,
    "Link kopiert!"
  ],
  "Live": [
    null,
    "Live"
  ],
  "Liverpool": [
    null,
    "-"
  ],
  "Loading": [
    null,
    "Ladevorgang"
  ],
  "Loading in progress": [
    null,
    "Ladevorgang läuft"
  ],
  "Log in": [
    null,
    "Anmelden"
  ],
  "Log in to %1$s": [
    null,
    "Auf %1$s anmelden"
  ],
  "Lost": [
    null,
    "Verloren"
  ],
  "Maintenance in progress": [
    null,
    "Im Moment läuft die Wartung"
  ],
  "Maintenance in progress.": [
    null,
    "Wartungsarbeiten laufen."
  ],
  "Manchester City": [
    null,
    "-"
  ],
  "Manchester United": [
    null,
    "-"
  ],
  "Map %1$s": [
    null,
    "Map %1$s"
  ],
  "Marseille": [
    null,
    "-"
  ],
  "Match": [
    null,
    "Match"
  ],
  "Match details": [
    null,
    "Matchdetails"
  ],
  "Match details and odds": [
    null,
    "-"
  ],
  "Match ended": [
    null,
    "Spielende"
  ],
  "Match odds": [
    null,
    "Quoten des Spiels"
  ],
  "Match result odds": [
    null,
    "-"
  ],
  "Match unavailable": [
    null,
    "Match nicht verfügbar"
  ],
  "Matches": [
    null,
    "Spiele"
  ],
  "Maximum selections reached": [
    null,
    "Höchstanzahl der möglichen Auswahlen erreicht"
  ],
  "Min. odds": [
    null,
    "Min. Quote"
  ],
  "Min. odds:": [
    null,
    "Min. Quote:"
  ],
  "Min. wager:": [
    null,
    "Mindesteinsatz:"
  ],
  "Minimum odds to win this card: %1$s": [
    null,
    "Mindestquoten, um diese Strasse zu gewinnen: %1$s"
  ],
  "Minimum odds to win this level: %1$s": [
    null,
    "Mindestquote, um dieses Level zu gewinnen: %1$s"
  ],
  "Monopoly internal error": [
    null,
    "Interner Fehler bei dem Monopoly"
  ],
  "More selections": [
    null,
    "Mehr anzeigen"
  ],
  "Most advanced": [
    null,
    "-"
  ],
  "Most expensive": [
    null,
    "-"
  ],
  "Most popular": [
    null,
    "-"
  ],
  "Most recent": [
    null,
    "-"
  ],
  "Multiples:": [
    null,
    "Kombinationen:"
  ],
  "Multiscorers": [
    null,
    "Mehrfacher Torschütze"
  ],
  "My bets": [
    null,
    "Meine Wetten"
  ],
  "My collection": [
    null,
    "Meine Kollektion"
  ],
  "My favourites": [
    null,
    "Meine Favoriten"
  ],
  "My grids": [
    null,
    "-"
  ],
  "My wager": [
    null,
    "-"
  ],
  "My winnings": [
    null,
    "-"
  ],
  "MyMatch currently unavailable": [
    null,
    "MyMatch momentan nicht verfügbar."
  ],
  "MyMatch mode": [
    null,
    ""
  ],
  "MyMatch unavailable": [
    null,
    "MyMatch nicht verfügbar"
  ],
  "News": [
    null,
    "News"
  ],
  "Next": [
    null,
    "Weiter"
  ],
  "Next grid": [
    null,
    "-"
  ],
  "Next grids": [
    null,
    "-"
  ],
  "No": [
    null,
    "Nein"
  ],
  "No bets": [
    null,
    "Keine Wette"
  ],
  "No grid": [
    null,
    "-"
  ],
  "No grid played": [
    null,
    "-"
  ],
  "No grids": [
    null,
    "-"
  ],
  "No grids cancelled": [
    null,
    "-"
  ],
  "No grids lost": [
    null,
    "-"
  ],
  "No grids running": [
    null,
    "-"
  ],
  "No grids won": [
    null,
    "-"
  ],
  "No public grids": [
    null,
    "-"
  ],
  "No rank 1 winners": [
    null,
    "-"
  ],
  "No results": [
    null,
    "Kein Ergebnis"
  ],
  "No team": [
    null,
    "Keine Mannschaft"
  ],
  "Non-top 10 competitor": [
    null,
    "Teilnehmer außerhalb der Top 10"
  ],
  "Non-top 30 competitor": [
    null,
    "Teilnehmer außerhalb der Top 30"
  ],
  "Not enough combinations": [
    null,
    "Zu wenige Kombinationen"
  ],
  "Notifications": [
    null,
    "Benachrichtigungen"
  ],
  "Number": [
    null,
    "-"
  ],
  "Number of bets": [
    null,
    "Anzahl Wetten"
  ],
  "Number of goals from the player": [
    null,
    "Anzahl der Tore des Spielers"
  ],
  "Odds": [
    null,
    "Quote"
  ],
  "Odds equal or inferior to 1": [
    null,
    "Quoten kleiner oder gleich 1"
  ],
  "Odds:": [
    null,
    "Quote:"
  ],
  "Official lineups": [
    null,
    "Offizielle Aufstellungen"
  ],
  "Official starting lineups": [
    null,
    "Offiziele Starting Five"
  ],
  "Ok": [
    null,
    "Ok"
  ],
  "Olympiakos": [
    null,
    "-"
  ],
  "One or multiple selections are unavailable": [
    null,
    "Eine oder mehrere Auswahlen sind nicht verfügbar"
  ],
  "Ongoing": [
    null,
    "Live"
  ],
  "Oops,": [
    null,
    "Oops,"
  ],
  "Open the App Store": [
    null,
    "App Store öffnen"
  ],
  "PRA": [
    null,
    "PRA"
  ],
  "Paris SG": [
    null,
    "-"
  ],
  "Penalty": [
    null,
    "Elfmeter"
  ],
  "Penalty try": [
    null,
    "Penalty try"
  ],
  "Pending %1$s bets": [
    null,
    "Anhängige %1$s Wetten"
  ],
  "Pending bet refused": [
    null,
    "Wette nicht möglich"
  ],
  "Pending bet validated": [
    null,
    "Anhängige Wette bestätigt"
  ],
  "Permanent and past promotions": [
    null,
    "Unsere Angebote"
  ],
  "Phase 1: Pegasus Shoes": [
    null,
    "1. Phase: Der fliegende Pegasos"
  ],
  "Phase 2: The remote control ball": [
    null,
    "2. Phase: Der ferngesteuerte Ball"
  ],
  "Phase 3: The Chameleon Jersey": [
    null,
    "3. Phase: Das Chamäleon-Trikot"
  ],
  "Place a series of winning bets to score %1$s points.": [
    null,
    "Gewinnt eure Wetten, um %1$s Punkte zu erzielen."
  ],
  "Play the game to try and win a ton of Freebets!": [
    null,
    "Nimm am Spiel teil und versuche möglichst viele Freebets zu gewinnen!"
  ],
  "Player": [
    null,
    "-"
  ],
  "Player vs. player": [
    null,
    "Spieler gegen Spieler"
  ],
  "Player vs. team": [
    null,
    "Spieler gegen Mannschaft"
  ],
  "Please enter a valid amount.": [
    null,
    "-"
  ],
  "Please enter your date of birth": [
    null,
    "Das Geburtsdatum ist erforderlich"
  ],
  "Points": [
    null,
    "Punkte"
  ],
  "Points structure: 100 x product (winning odds). Thus, if your first 3 bets are winners, you win 100 x odds1 x odds2 x odds3 points.": [
    null,
    "Punktesystem: 100 x Produkt (gewonnene Quoten). Gewinnt ihr eure ersten drei Wetten, erhaltet ihr somit 100 x Quote1 x Quote2 x Quote3 Punkte."
  ],
  "Points+assists": [
    null,
    "Punkte+assists"
  ],
  "Points+rebounds": [
    null,
    "Punkte+rebounds"
  ],
  "Poker": [
    null,
    "Poker"
  ],
  "Potential winnings": [
    null,
    "Möglicher Gewinn"
  ],
  "Previous": [
    null,
    "Zurück"
  ],
  "Prize distribution per player": [
    null,
    "-"
  ],
  "Prizepool": [
    null,
    "Dotierung"
  ],
  "Probable starting lineups": [
    null,
    "Mögliche Starting Five"
  ],
  "Prohibited": [
    null,
    "Verboten"
  ],
  "Prohibited (no-stakes game)": [
    null,
    "Verboten (Spiel ohne Anreiz)"
  ],
  "Projected lineups": [
    null,
    "Voraussichtliche Aufstellungen"
  ],
  "Provisional grid result": [
    null,
    "-"
  ],
  "Provisional prize distribution": [
    null,
    "-"
  ],
  "Public grid": [
    null,
    "-"
  ],
  "Public grids": [
    null,
    "-"
  ],
  "Real Madrid": [
    null,
    "-"
  ],
  "Rebounds": [
    null,
    "Rebounds"
  ],
  "Ref:": [
    null,
    "Ref:"
  ],
  "Reference": [
    null,
    "-"
  ],
  "Reference bet: the smallest bet of the levels you have won (max %1$s)": [
    null,
    "Referenzeinsatz: Der kleinste getätigte Wetteinsatz auf das gewonnene Level (max. %1$s)"
  ],
  "Refuse": [
    null,
    "Ablehnen"
  ],
  "Refused": [
    null,
    "Abgebrochen"
  ],
  "Repeat this bet": [
    null,
    "Zur Wette zurückkehren"
  ],
  "Reset": [
    null,
    "Reset"
  ],
  "Reset the grid": [
    null,
    "-"
  ],
  "Result": [
    null,
    "-"
  ],
  "Retired or defaulted": [
    null,
    "Aufgabe oder Disqualifikation"
  ],
  "Reviews": [
    null,
    "-"
  ],
  "Right-click an image to copy it or to save it on your device": [
    null,
    "Rechtsklick auf ein Bild um es zu kopieren oder auf eurem Gerät zu speichern"
  ],
  "Rules": [
    null,
    "Regeln"
  ],
  "Running": [
    null,
    "-"
  ],
  "Save bet": [
    null,
    "Wette speichern"
  ],
  "Save my selection": [
    "Save my selections",
    "Meinen Tipp speichern",
    "Meine Tipps speichern"
  ],
  "Saved": [
    null,
    "Gespeichert"
  ],
  "Scan a bonus code": [
    null,
    "Bonus-Code scannen"
  ],
  "Scorer": [
    null,
    "Torschütze"
  ],
  "Scorer type": [
    null,
    "Art des Tores des Spielers"
  ],
  "Scorers": [
    null,
    "Torschützen"
  ],
  "Search": [
    null,
    "Wettsuche"
  ],
  "See all": [
    null,
    "Alle ansehen"
  ],
  "See all odds": [
    null,
    "-"
  ],
  "See details": [
    null,
    "Details"
  ],
  "See more selections": [
    null,
    "Mehr anzeigen"
  ],
  "See top matches": [
    null,
    "Zu den Top-Spielen"
  ],
  "Select": [
    null,
    "Auswählen"
  ],
  "Service unavailable": [
    null,
    "Dienst nicht verfügbar"
  ],
  "Settings": [
    null,
    "Einstellungen"
  ],
  "Shaktar Donetsk": [
    null,
    "-"
  ],
  "Share bet to a friend's basket": [
    null,
    "Wettschein mit einem Freund teilen"
  ],
  "Share image": [
    null,
    "Bild teilen"
  ],
  "Share my bet": [
    null,
    "Meine Wette teilen"
  ],
  "Share options": [
    null,
    "Teilen (weitere Optionen)"
  ],
  "Shop": [
    null,
    "Boutique"
  ],
  "Show animation when adding a selection to betslip": [
    null,
    "Zeige Animation beim Hinzufügen einer Wette"
  ],
  "Show bet": [
    null,
    "Wette ausblenden"
  ],
  "Show username": [
    null,
    "Pseudo zeigen"
  ],
  "Show wager and winnings": [
    null,
    "Einsatz und Gewinn zeigen"
  ],
  "Sign-in": [
    null,
    "Anmelden"
  ],
  "Sign-in and place bet": [
    null,
    "Anmelden und wetten"
  ],
  "Sign-up": [
    null,
    "Konto eröffnen"
  ],
  "Simple touchdown scorer": [
    null,
    "Scorer"
  ],
  "Single": [
    null,
    "Einzel"
  ],
  "Skip all": [
    null,
    "Alles überspringen"
  ],
  "Sports": [
    null,
    "Sportarten"
  ],
  "Sports bets": [
    null,
    "Sportwetten"
  ],
  "St Patrick": [
    null,
    "St Patrick"
  ],
  "St Valentine": [
    null,
    "Valentinstag"
  ],
  "Start": [
    null,
    "Los geht’s"
  ],
  "Start again": [
    null,
    "Neustarten"
  ],
  "Starter": [
    null,
    "i. d. Startelf"
  ],
  "Starters": [
    null,
    "Startelf"
  ],
  "Starting 5 Guarantee": [
    null,
    "Starting Five-Garantie"
  ],
  "Stats": [
    null,
    "Statistik"
  ],
  "Steals": [
    null,
    "Steals"
  ],
  "Steals+blocks": [
    null,
    "Steals+blocks"
  ],
  "Substitutes": [
    null,
    "Auswechselspieler"
  ],
  "System": [
    null,
    "System"
  ],
  "System %1$s": [
    null,
    "System %1$s"
  ],
  "System %1$s/%2$s": [
    null,
    "System %1$s/%2$s"
  ],
  "System bet": [
    null,
    "Systemwette"
  ],
  "System grid": [
    null,
    "-"
  ],
  "System grid price": [
    null,
    "-"
  ],
  "Take part": [
    null,
    "-"
  ],
  "Team 1": [
    null,
    "-"
  ],
  "Team 2": [
    null,
    "-"
  ],
  "Team grid": [
    null,
    "-"
  ],
  "Terms and Conditions and Privacy Policy": [
    null,
    "Allgemeine Geschäftsbedingungen und Datenschutzbestimmung"
  ],
  "The Gift Race": [
    null,
    "Wettlauf der Geschenke"
  ],
  "The Pegasus shoes to fly over your next match": [
    null,
    "Der fliegende Pegasos, um zum nächsten Spiel zu fliegen"
  ],
  "The bet is not eligible for Boom %1$s because Freebets are not taken into account": [
    null,
    "Die Wette kann nicht für Boom %1$s gewertet werden, da Freebets nicht berücksichtigt werden"
  ],
  "The bet is not eligible for Monopoly because Freebets are not taken into account": [
    null,
    "Die Wette ist nicht für Monopoly zulässig, da Einsätze mit Freebets nicht berücksichtigt werden"
  ],
  "The chameleon jersey to change teams in a flash": [
    null,
    "Das Chamäleon-Trikot, um blitzschnell die Mannschaft zu wechseln"
  ],
  "The classic accumulator wins if the %1$s are correct": [
    null,
    "Klassische Kombiwette, gewinnt wenn %1$s korrekt sind"
  ],
  "The date of birth entered does not match the date registered on your account": [
    null,
    "Das angegebene Geburtsdatum entspricht nicht dem des Kontos"
  ],
  "The date of birth you have entered is invalid": [
    null,
    "Das angegebene Geburtsdatum ist ungültig."
  ],
  "The game is over": [
    null,
    "Das Tippspiel ist vorbei"
  ],
  "The game will end in under 24 hours": [
    null,
    "Das Spiel endet in weniger als 24 Stunden"
  ],
  "The maximum stake for this bet has already been reached, or the stake is lower than the minimum of €0.10": [
    null,
    "Der Höchsteinsatz für diese Wette ist bereits erreicht oder liegt unter dem Mindesteinsatz von 0,10 €"
  ],
  "The maximum wager is %1$s": [
    null,
    "Der maximale Einsatz für diese Wette beträgt %1$s"
  ],
  "The minimum odds are %1$s": [
    null,
    "Die Mindestquote ist %1$s"
  ],
  "The minimum wager is %1$s": [
    null,
    "Der Mindesteinsatz beträgt %1$s"
  ],
  "The odds have changed": [
    null,
    "Die Quote hat sich geändert"
  ],
  "The prize for this collection has already been claimed": [
    null,
    "Die mit dieser Sammlung verbundene Belohnung wurde sich bereits geholt"
  ],
  "The remote-controlled ball with its unpredictable trajectories": [
    null,
    "Der ferngesteuerte Ball und seine unvorhersehbaren Flugbahnen"
  ],
  "The service is currently unavailable. We will restore this as soon as possible. We apologise for any inconveniences caused by this.": [
    null,
    "Der Dienst ist vorübergehend nicht verfügbar. Er wird so schnell wie möglich wiederhergestellt. Bitte entschuldigen Sie die Unannehmlichkeiten."
  ],
  "The system grid is an expert mode. It allows you to create complex grids with some basic matches.": [
    null,
    "-"
  ],
  "The video could not be loaded as it is an unsupported video format or due to a server issue.": [
    null,
    "Das Video konnte aufgrund eines nicht unterstützten Formats oder eines Serverfehlers nicht geladen werden."
  ],
  "This QR code is not a Winamax bonus code": [
    null,
    "Dieser QR-Code ist keine Winamax Bonus-Code"
  ],
  "This broadcast is not available in your country of residence.": [
    null,
    "Diese Übertragung ist in ihrem Land leider nicht verfügbar. "
  ],
  "This code is not a Winamax bonus code or has already been credited": [
    null,
    "Dieser Code ist kein Winamax Bonus-Code oder wurde bereits verwendet"
  ],
  "This event is no longer available": [
    null,
    "Das Event steht nicht mehr zur Verfügung"
  ],
  "This free bet cannot be used": [
    null,
    "Es ist nicht möglich, diese Gratiswette zu nutzen"
  ],
  "This match is already included in the betslip you wish to enhance.": [
    null,
    "Dieses Spiel ist bereits in der Wette enthalten, die Du ergänzen möchtest."
  ],
  "This promotion has ended": [
    null,
    "Diese Promotion ist beendet"
  ],
  "This promotion will end in under 24 hours": [
    null,
    "Diese Promotion endet in weniger als 24 Stunden"
  ],
  "This version of the software is not supported": [
    null,
    "This version of the software is not supported"
  ],
  "This video could not be loaded as it has unsupported functionalities.": [
    null,
    "Das Video konnte aufgrund nicht unterstützter Funktionen nicht geladen werden."
  ],
  "Three-pointers": [
    null,
    "3-Punkte"
  ],
  "Tick the boxes in your grid.": [
    null,
    "-"
  ],
  "To be won": [
    null,
    "Zu gewinnen"
  ],
  "Tomorrow": [
    null,
    "Morgen"
  ],
  "Too many attempts.": [
    null,
    "Zu viele Versuche."
  ],
  "Too many bankers": [
    null,
    "Zu viele Bank-Tipps"
  ],
  "Too many bets selected": [
    null,
    "Zu viele zugrundeliegende Tipps"
  ],
  "Too many selections": [
    null,
    "Zu viele Tipps"
  ],
  "Top competitions": [
    null,
    "Top-Wettbewerbe"
  ],
  "Total": [
    null,
    "Insgesamt"
  ],
  "Total away": [
    null,
    "Auswärts Gesamt"
  ],
  "Total home": [
    null,
    "Heim Gesamt"
  ],
  "Total odds": [
    null,
    "Gesamtquote"
  ],
  "Total wager": [
    null,
    "Gesamteinsatz"
  ],
  "Total winnings": [
    null,
    "Gesamtgewinn"
  ],
  "Touchdowns scorers": [
    null,
    "Touchdowns-Scorers"
  ],
  "Try again": [
    null,
    "Nochmal versuchen"
  ],
  "Try scorer Duo": [
    null,
    "Try-Scorer-Duo"
  ],
  "Try scorer Trio": [
    null,
    "Try-Scorer-Trio"
  ],
  "Try scorers": [
    null,
    "Try-Scorers"
  ],
  "Try:": [
    null,
    "Versuchen:"
  ],
  "Turnovers": [
    null,
    "Turnovers"
  ],
  "Type of goal scored by a team": [
    null,
    "Art des Tores einer Mannschaft"
  ],
  "Unable to calculate odds": [
    null,
    "Berechnung der Quote nicht möglich"
  ],
  "Upcoming matches": [
    null,
    "Kommende Spiele (Kalender)"
  ],
  "Update": [
    null,
    "Aktualisieren"
  ],
  "Use Freebets": [
    null,
    "Freebets verwenden"
  ],
  "Use a bonus": [
    null,
    "Einen Bonus benutzen"
  ],
  "Video unavailable": [
    null,
    "Video nicht verfügbar"
  ],
  "View my bet": [
    null,
    "Meine Wette ansehen"
  ],
  "View the most wagered bets in the last %1$s mins": [
    null,
    "Die beliebtesten Wetten in den letzten %1$s Minuten"
  ],
  "View the most wagered bets in the last hour": [
    null,
    "Die beliebtesten Wetten in der letzten Stunde"
  ],
  "Wager": [
    null,
    "Einsatz"
  ],
  "Wager:": [
    null,
    "Einsatz:"
  ],
  "Walkover": [
    null,
    "Walkover"
  ],
  "Want another accumulator? Switch to MyMatch!": [
    null,
    "Du willst eine andere Kombination? Wechsle in den MyMatch-Modus!"
  ],
  "Want another multi-chance accumulator? Switch to MyMatch!": [
    null,
    "Du willst eine andere Kombination der Multi-Chance? Wechsle in den MyMatch-Modus!"
  ],
  "Want to check out all the promotions Winamax has to offer?": [
    null,
    "Du willst alle Angebote von Winamax entdecken?"
  ],
  "Warning:": [
    null,
    "Achtung:"
  ],
  "We were unable to generate your final image": [
    null,
    "Wir konnten dein endgültiges Bild nicht generieren"
  ],
  "We'll explain everything step by step!": [
    null,
    "-"
  ],
  "Welcome to the grid tutorial": [
    null,
    "-"
  ],
  "Win a ton of Freebets along the way!": [
    null,
    "Gewinnt auf eurem Wege jede Menge Freebets!"
  ],
  "Win all previous levels in order to unlock this level": [
    null,
    "Gewinne alle vorherigen Level um dieses Level freizuschalten"
  ],
  "Win up to": [
    null,
    "Gewinne bis zu"
  ],
  "Win up to %1$s times your reference bet in Freebets!": [
    null,
    "Gewinne bis zum %1$s- fachen deines Mindesteinsatzes in Freebets."
  ],
  "WinaTV channel": [
    null,
    "Winamax TV Channel"
  ],
  "Winamax QR code": [
    null,
    "Winamax QR-Code"
  ],
  "Winamax grid": [
    null,
    "-"
  ],
  "Winning is everything": [
    null,
    "Die besten quoten"
  ],
  "Winnings": [
    null,
    "Gewinn"
  ],
  "Winnings %1$s": [
    null,
    "Gewinn %1$s"
  ],
  "Winnings inferior or equal to the wager": [
    null,
    "Gewinne kleiner oder gleich dem Einsatz"
  ],
  "Won": [
    null,
    "Gewonnen"
  ],
  "Xmas": [
    null,
    "Xmas"
  ],
  "Yes": [
    null,
    "Ja"
  ],
  "You aborted the media playback.": [
    null,
    "Du hast die Videowiedergabe unterbrochen."
  ],
  "You are currently excluded from Monopoly due to your game limits": [
    null,
    "Ihr seid aktuell vom Monopoly, wegen eurer Spielgrenzen, ausgeschlossen"
  ],
  "You are currently excluded from betting promotions in your %1$s": [
    null,
    "Dein %1$s lässt gerade keine weiteren Sportwetten zu."
  ],
  "You are currently excluded from the Gift Race due to your game limits": [
    null,
    "Ihr seid aktuell vom Wettlauf der Geschenke, wegen eurer Spielgrenzen, ausgeschlossen"
  ],
  "You are currently ineligible for Boom %1$s": [
    null,
    "Ihr seid aktuell nicht teilnahmeberechtigt, um am Boom %1$s teilzunehmen"
  ],
  "You are currently ineligible for Monopoly": [
    null,
    "Ihr seid aktuell nicht teilnahmeberechtigt, um am Monopoly teilzunehmen"
  ],
  "You are currently ineligible for the Gift Race": [
    null,
    "Ihr seid aktuell nicht teilnahmeberechtigt, um am Wettlauf der Geschenke teilzunehmen"
  ],
  "You are currently not eligible to betting promotions": [
    null,
    "Du bist gerade von unserem Sportwettenangebot ausgeschlossen."
  ],
  "You are not authorized to connect from this country.": [
    null,
    "Aus diesem Land ist eine Anmeldung nicht möglich."
  ],
  "You can also make doubles or triples to increase your chances of winning": [
    null,
    "-"
  ],
  "You can also select doubles and triples to have a better chance of winning.": [
    null,
    "-"
  ],
  "You can do so right here! :index_vers_le_bas:": [
    null,
    "Dann bist Du hier richtig!"
  ],
  "You can select doubles and triples to increase your chances of winning.": [
    null,
    "-"
  ],
  "You cannot bet on this grid anymore": [
    null,
    "-"
  ],
  "You cannot combine multiple bets on the same match": [
    null,
    "Es ist nicht möglich, verschiedenen Wetten einer Begegnung zu kombinieren"
  ],
  "You cannot combine these bets": [
    null,
    "Es ist nicht möglich, diese Wetten zu kombinieren"
  ],
  "You have already placed the same bet recently": [
    null,
    "Sie haben diese Wette vor kurzem schon abgegeben"
  ],
  "You have already received your reward": [
    null,
    "Du hast deine Belohnung bereits erhalten"
  ],
  "You have been active for %1$s minutes now.": [
    null,
    "Du bist jetzt schon seit %1$s Minuten aktiv."
  ],
  "You have exceeded the maximum stake for this bet": [
    null,
    "Der Höchsteinsatz für diese Wette ist überschritten"
  ],
  "You have made a request to change your password. Please check your emails.": [
    null,
    "Sie haben eine Anfrage zur Änderung Ihres Passworts gesendet. Bitte rufen Sie Ihre E-Mails ab."
  ],
  "You have no favourites": [
    null,
    "Keine Favoriten"
  ],
  "You have no funds in your account.": [
    null,
    "-"
  ],
  "You lose": [
    null,
    "Verloren"
  ],
  "You may not receive a booster on this bet": [
    null,
    "Bei dieser Wette können Sie nicht vom Booster profitieren"
  ],
  "You must be logged": [
    null,
    "Sie müssen angemeldet sein"
  ],
  "You must be logged in to see this page": [
    null,
    "Sie müssen angemeldet sein, um diese Seite sehen zu können"
  ],
  "You must be logged in to validate your bets": [
    null,
    "Sie müssen angemeldet sein, um die Wette zu bestätigen"
  ],
  "You must be logged in to validate your grid.": [
    null,
    "-"
  ],
  "You must be of majority age to play": [
    null,
    "Sie müssen volljährig sein, um sich anmelden zu können."
  ],
  "You must have a minimum of €1 on your account, or you must have placed a bet on this match.": [
    null,
    "Sie müssen über mindestens 1 € Guthaben verfügen oder eine Wette auf dieses Match platziert haben."
  ],
  "You must log in to %1$s in order to access your account.": [
    null,
    "Sie müssen sich auf %1$s anmelden, um Zugriff auf Ihren Account zu haben."
  ],
  "You must select doubles or triples to make a team grid.": [
    null,
    "-"
  ],
  "You must tick at least one box per line.": [
    null,
    "-"
  ],
  "You must wager your deposit in order to withdraw it": [
    null,
    ""
  ],
  "You only have %1$s": [
    null,
    "Sie verfügen nur über %1$s"
  ],
  "You only have %1$s in Freebets available": [
    null,
    "Du verfügst über %1$s in Freebets"
  ],
  "You will earn between %1$s and %2$s times your reference bet in Freebets.": [
    null,
    "So gewinnt ihr zwischen dem %1$s- und %2$s-fachen eures Mindesteinsatzes in Freebets."
  ],
  "You will exceed your daily limit. The maximum wager is %1$s": [
    null,
    "Sie würden Ihre tägliche Spielgrenze überschreiten. Der Maximaleinsatz beträgt %1$s"
  ],
  "You will exceed your monthly limit. The maximum wager is %1$s": [
    null,
    "Sie würden Ihre monatliche Spielgrenze überschreiten. Der Maximaleinsatz beträgt %1$s"
  ],
  "You will exceed your weekly limit. The maximum wager is %1$s": [
    null,
    "Sie würden Ihre wöchentliche Spielgrenze überschreiten. Der Maximaleinsatz beträgt %1$s"
  ],
  "You win": [
    null,
    "Gewonnen"
  ],
  "You win Freebets": [
    null,
    "Du gewinnst Freebets"
  ],
  "You won Freebets": [
    null,
    "Du gewinnst eine Gratiswette von"
  ],
  "You've already won everything!": [
    null,
    "Du hast schon alles gewonnen!"
  ],
  "Your %1$s bet could not be cashed out": [
    null,
    "Die Wette %1$s konnte nicht zurückgekauft werden"
  ],
  "Your %1$s bet has been validated": [
    null,
    "-"
  ],
  "Your %1$s bet was cashed out for %2$s": [
    null,
    "Cashout der Wette %1$s für %2$s erfolgt"
  ],
  "Your account is frozen.": [
    null,
    "Ihr Konto ist blockiert."
  ],
  "Your account is locked": [
    null,
    "Dein Account ist gesperrt"
  ],
  "Your account is not authorized for use in this region": [
    null,
    "Es ist nicht gestattet, von Ihrem Konto aus eine Verbindung mit dieser Plattform herzustellen"
  ],
  "Your app is out of date, please update to the latest version": [
    null,
    "Deine App-Version ist veraltet, du musst sie bitte aktualisieren."
  ],
  "Your betslip is empty!": [
    null,
    "Dein Wettschein ist leer!"
  ],
  "Your bonus code has been accepted": [
    null,
    "Ihr Bonus-Code wurde berücksichtigt"
  ],
  "Your email address has not been verified. Please check your emails.": [
    null,
    "Ihre E-Mail-Adresse wurde nicht validiert. Bitte überprüfen Sie ihre E-Mails."
  ],
  "Your grid has %1$s double": [
    "Your grid has %1$s doubles",
    "-",
    ""
  ],
  "Your grid has been validated.": [
    null,
    "-"
  ],
  "Your grid will only be validated once it has been entirely financed.": [
    null,
    "-"
  ],
  "Your mission is simple:": [
    null,
    "Eure Mission ist einfach:"
  ],
  "Your participation in the game has already been validated": [
    null,
    "Deine Teilnahme am Spiel wurde bereits bestätigt"
  ],
  "Your turn to play!": [
    null,
    "-"
  ],
  "Your winnings of %1$s will be credited to you as soon as all bets are settled.": [
    null,
    "Dir wird dein Gewinn von %1$s gutgeschrieben, sobald alle Wetten ausgewertet sind."
  ],
  "abandoned": [
    null,
    "Aufgabe"
  ],
  "already received": [
    null,
    "bereits gewonnen"
  ],
  "and %1$s triple": [
    "and %1$s triples",
    "-",
    ""
  ],
  "break": [
    null,
    "Pause"
  ],
  "collected": [
    null,
    "-"
  ],
  "delayed": [
    null,
    "Verspätet"
  ],
  "events in progress": [
    null,
    "Live Wetten"
  ],
  "extra innings": [
    null,
    "Extra-Inning"
  ],
  "extra-time": [
    null,
    "Verlängerung"
  ],
  "extra-time - 1st half": [
    null,
    "Verlängerung - 1. Halbzeit"
  ],
  "extra-time - 2nd half": [
    null,
    "Verlängerung - 2. Halbzeit"
  ],
  "extra-time finished": [
    null,
    "Ende der Verlängerung"
  ],
  "extra-time half-time": [
    null,
    "Halbzeit der Verlängerung"
  ],
  "extra-time will begin": [
    null,
    "Die Verlängerung beginnt in Kürze"
  ],
  "free": [
    null,
    "Free"
  ],
  "gaming limits": [
    null,
    "Spiellimit"
  ],
  "golden set": [
    null,
    "Goldener Satz"
  ],
  "grid %1$s n°%2$s": [
    null,
    "-"
  ],
  "grids": [
    null,
    "-"
  ],
  "guaranteed": [
    null,
    "-"
  ],
  "half-time": [
    null,
    "Halbzeit"
  ],
  "handicap format": [
    null,
    "Handicap-Format"
  ],
  "how it works": [
    null,
    "-"
  ],
  "in progress": [
    null,
    "Live"
  ],
  "including %1$s:": [
    null,
    "davon %1$s:"
  ],
  "including rank 1 deferral:": [
    null,
    "-"
  ],
  "match abandoned": [
    null,
    "Spiel abgebrochen"
  ],
  "match delayed": [
    null,
    "Begegnung verspätet"
  ],
  "match finished": [
    null,
    "Ende der Begegnung"
  ],
  "match in progress": [
    null,
    "Live"
  ],
  "match interrupted": [
    null,
    "Begegnung unterbrochen"
  ],
  "match interuppted": [
    null,
    "Begegnung unterbrochen"
  ],
  "match postponed": [
    null,
    "Begegnung verschoben"
  ],
  "match started": [
    null,
    "Live"
  ],
  "missions:AlreadyOpted": [
    null,
    "Teilnahme bestätigt"
  ],
  "missions:Log in": [
    null,
    "Anmelden"
  ],
  "missions:Opt in": [
    null,
    "Ich nehme teil"
  ],
  "most popular": [
    null,
    "am meisten gespielt"
  ],
  "no events": [
    null,
    "Keine Events"
  ],
  "n°": [
    null,
    "-"
  ],
  "of the base": [
    "of %1$s bases",
    "der Bank",
    "der %1$s Banken"
  ],
  "ok": [
    null,
    "-"
  ],
  "or": [
    null,
    "oder"
  ],
  "overtime": [
    null,
    "Verlängerung"
  ],
  "overtime finished": [
    null,
    "Ende der Verlängerung"
  ],
  "overtime will begin": [
    null,
    "Die Verlängerung beginnt in Kürze"
  ],
  "own goal": [
    null,
    "Eigentor"
  ],
  "pause": [
    null,
    "Pause"
  ],
  "penalty": [
    null,
    "Elfmeter"
  ],
  "penalty shoot-out": [
    null,
    "Penaltys"
  ],
  "retired": [
    null,
    "Nicht angetreten"
  ],
  "selection": [
    "selections",
    "Wette",
    "Wetten"
  ],
  "session break": [
    null,
    "Session Break"
  ],
  "sudden death": [
    null,
    "Sudden Death"
  ],
  "text format": [
    null,
    "Text-Format"
  ],
  "the 2nd quarter will begin": [
    null,
    "Das 2. Viertel beginnt in Kürze"
  ],
  "the 2nd set will begin": [
    null,
    "Der 2. Satz beginnt in Kürze"
  ],
  "the 3rd quarter will begin": [
    null,
    "Das 3. Viertel beginnt in Kürze"
  ],
  "the 3rd set will begin": [
    null,
    "Der 3. Satz beginnt in Kürze"
  ],
  "the 4th quarter will begin": [
    null,
    "Das 4. Viertel beginnt in Kürze"
  ],
  "the 4th set will begin": [
    null,
    "Der 4. Satz beginnt in Kürze"
  ],
  "the 5th set will begin": [
    null,
    "Der 5. Satz beginnt in Kürze"
  ],
  "timer:d": [
    null,
    "T"
  ],
  "timer:finished": [
    null,
    "Beendet"
  ],
  "timer:h": [
    null,
    "Std"
  ],
  "timer:min": [
    null,
    "Min"
  ],
  "up to": [
    null,
    "bis"
  ],
  "walkover": [
    null,
    "Nicht angetreten"
  ],
  "with your next deposit": [
    null,
    "mit Deiner nächsten Einzahlung"
  ]
}
  }
}
